'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _smartBanner = require('./smartBanner.html');

var _smartBanner2 = _interopRequireDefault(_smartBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smartBanner = {
    template: _smartBanner2.default,
    controller: function controller($rootScope) {
        var vm = this;
        vm.isMobileWebBrowser = $rootScope.isMobileWebBrowser;
        vm.isIos = $rootScope.isIos;
        vm.isAndroid = $rootScope.isAndroid;
        vm.open = !(JSON.parse(localStorage.getItem('smartbanner-open')) == false);

        vm.init = function () {
            $rootScope.isSmartBannerDisplayed = $rootScope.isMobileWebBrowser && vm.open;
            vm.banner.appUrl = vm.isAndroid ? 'https://play.google.com/store/apps/details?id=com.advinda.investorCloud' : 'https://appsto.re/in/ob84ib.i';
        };

        vm.banner = {
            title: 'advinda Investor Cloud',
            subtitle: 'advinda.com',
            ios_text: 'GET - On the App Store',
            android_text: 'GET - On the Google Play Store',
            mode: '',
            appImage: 'assets/img/advinda-icon.png',
            appUrl: '',
            callToAction: 'View'
        };

        vm.isMobile = function () {
            return vm.isMobileWebBrowser || true;
        };

        vm.close = function () {
            localStorage.setItem('smartbanner-open', false);
            vm.open = false;
        };
    }
};

exports.default = smartBanner;


/** WEBPACK FOOTER **
 ** ./src/app/directives/smartBanner/smartBanner.js
 **/